"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorLogger = void 0;
const LogLevel_1 = require("./LogLevel");
/**
 * Error Logging class for Renderer
 *
 */
class ErrorLogger {
    // private static ErrorLogger _el;
    static LoggerName = "ErrorLogger";
    //private static Logger _Logger = null;//
    //private static final Logger _Logger = Logger.getLogger(LoggerName);
    static _level = LogLevel_1.LogLevel.INFO;
    //private static java.util.logging.FileHandler fh;
    static _LoggingEnabled = false;
    //private static String _LoggingPath = System.getProperty("user.dir");
    //date format: Nov 19, 2012 11:41:40 AM
    static dateFormatOptions = { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "numeric", second: "numeric" };
    /*
    private ErrorLogger()
    {
        Init();
    }


    private static synchronized ErrorLogger getInstance()
    {

        //if(_Logger == null)
        if(_el == null)
        {
            try
            {
                _el = new ErrorLogger();

            }
            catch(Exception exc)
            {
                System.err.println(exc.message);
                //JOptionPane.showMessageDialog(null, ioe.message, "Message", JOptionPane.PLAIN_MESSAGE);
            }
        }

        return _el;
    }

    private void Init()
    {
        try
        {
            if(_Logger != null)
                _Logger.setLevel(Level.INFO);
        }
        catch(Exception exc)
        {
            System.err.println(exc.message);
            //JOptionPane.showMessageDialog(null, ioe.message, "Message", JOptionPane.PLAIN_MESSAGE);
        }
    }//*/
    /**
     * True if logging is enabled
     * @return {@link Boolean}
     */
    static getLoggingStatus() {
        return ErrorLogger._LoggingEnabled;
    }
    /**
     * Takes a throwable and puts it's stacktrace into a string.
     * @param error {@link Error}
     * @return {@link String}
     */
    static getStackTrace(error) {
        try {
            return error.stack;
        }
        catch (exc) {
            if (exc instanceof Error) {
                ErrorLogger.LogException("ErrorLogger", "getStackTrace", exc);
                return "Error - couldn't retrieve stack trace";
            }
            else {
                throw exc;
            }
        }
    }
    /**
     * TRUE: Creates a file handler that will log message to a file.
     * FALSE: logging just goes to console.
     * @param enable {@link Boolean}
     */
    static EnableLogging(enable) {
        ErrorLogger._LoggingEnabled = enable;
    }
    /**
     * Folder location to store the log file.
     * Defaults to "System.getProperty("user.dir")"
     * @param path {@link String}
     * @deprecated
     */
    static setLoggingPath(path) {
    }
    /**
     * clears log files that are beyond a passed number of days old
     * @param DaysOld {@link Integer}
     * @deprecated
     */
    static CleanupOldFiles(DaysOld) {
    }
    static setLevel(...args) {
        switch (args.length) {
            case 1: {
                const [newLevel] = args;
                ErrorLogger.setLevel(newLevel, false);
                break;
            }
            case 2: {
                const [newLevel, setConsoleHandler] = args;
                ErrorLogger._level = newLevel;
                /*
                _Logger.setLevel(newLevel);//set logger.
        
                if(fh != null)//handler that logs to file
                    fh.setLevel(newLevel);
        
                //have to set top logger/consle handler or messages will still
                //get blocked.
        
                //get the top logger
                if(setConsoleHandler)
                {
                    Logger topLogger = java.util.logging.Logger.getLogger("");
                    //Handler for console (resuse if it already exists)
                    Handler consoleHandler = null;
                    //see if there already is a console handler
                    for (Handler handler : topLogger.getHandlers())
                    {
                        if(handler instanceof ConsoleHandler)
                        {
                            //found the console handler
                            consoleHandler = handler;
                            break;
                        }
                    }
        
                    if(consoleHandler == null)
                    {
                        //there was no console handler found, create a new one
                        consoleHandler = new ConsoleHandler();
                        topLogger.addHandler(consoleHandler);
                    }
                    //set console handler to new level
                    consoleHandler.setLevel(newLevel);
                }//*/
                break;
            }
            default: {
                throw Error(`Invalid number of arguments`);
            }
        }
    }
    /**
     * Specify whether or not this logger should send its output
     * to it's parent Logger.  This means that any LogRecords will
     * also be written to the parent's Handlers, and potentially
     * to its parent, recursively up the namespace.
     * Defaults to true;
     *
     * @param useParentHandlers   true if output is to be sent to the
     *		logger's parent.
     */
    static setUseParentHandlers(useParentHandlers) {
        //_Logger.setUseParentHandlers(useParentHandlers);
    }
    /**
     * Gets the java.util.logging.Level that the logger is set to.
     * @return {@link Level}
     */
    static getLevel() {
        return ErrorLogger._level;
        //return _Logger.getLevel();
    }
    /**
     *
     * @return {@link String}
     * @deprecated
     */
    static getFileName() {
        //String path = _LoggingPath;//System.getProperty("user.dir");
        let fileName = "";
        /*
        SimpleDateFormat dateFormat = new SimpleDateFormat("_MMMdd");
        fileName = "TBCRendererLog" + dateFormat.format(new Date()) + ".txt";
        fileName = path + "\\" + fileName;
        //fileName = path.substring(0, 2) + "\\" + fileName;//*/
        return fileName;
    }
    static Entering(...args) {
        if (console) {
            switch (args.length) {
                case 2: {
                    const [sourceClass, sourceMethod] = args;
                    //_Logger.entering(sourceClass, sourceMethod);
                    if (ErrorLogger._level.intValue() <= LogLevel_1.LogLevel.FINER.intValue()) {
                        console.log("Entering: " + sourceClass + "." + sourceMethod);
                    }
                    break;
                }
                case 3: {
                    if (args[2] instanceof Array) {
                        const [sourceClass, sourceMethod, params] = args;
                        //_Logger.entering(sourceClass, sourceMethod,params);
                        if (ErrorLogger._level.intValue() <= LogLevel_1.LogLevel.FINER.intValue()) {
                            console.log("Entering: " + sourceClass + "." + sourceMethod + "with params:");
                            if (params != null) {
                                for (let param of params) {
                                    console.log(param.toString());
                                }
                            }
                        }
                    }
                    else {
                        const [sourceClass, sourceMethod, param1] = args;
                        //_Logger.entering(sourceClass, sourceMethod,param1);
                        if (ErrorLogger._level.intValue() <= LogLevel_1.LogLevel.FINER.intValue()) {
                            console.log("Entering: " + sourceClass + "." + sourceMethod +
                                " - " + param1.toString());
                        }
                    }
                    break;
                }
                default: {
                    throw Error(`Invalid number of arguments`);
                }
            }
        }
    }
    static Exiting(...args) {
        if (console) {
            switch (args.length) {
                case 2: {
                    const [sourceClass, sourceMethod] = args;
                    //_Logger.exiting(sourceClass, sourceMethod);
                    if (ErrorLogger._level.intValue() <= LogLevel_1.LogLevel.FINER.intValue()) {
                        console.log("Exiting: " + sourceClass + "." + sourceMethod);
                    }
                    break;
                }
                case 3: {
                    const [sourceClass, sourceMethod, result] = args;
                    //_Logger.exiting(sourceClass, sourceMethod, result);
                    if (ErrorLogger._level.intValue() <= LogLevel_1.LogLevel.FINER.intValue()) {
                        console.log("Entering: " + sourceClass + "." + sourceMethod +
                            " - " + result.toString());
                    }
                    break;
                }
                default: {
                    throw Error(`Invalid number of arguments`);
                }
            }
        }
    }
    static LogMessage(...args) {
        if (console) {
            switch (args.length) {
                case 1: {
                    const [message] = args;
                    ErrorLogger.LogMessage(message, LogLevel_1.LogLevel.INFO, false);
                    break;
                }
                case 2: {
                    const [message, showMessageBox] = args;
                    ErrorLogger.LogMessage(message, LogLevel_1.LogLevel.INFO, showMessageBox);
                    break;
                }
                case 3: {
                    if (args[2] instanceof Boolean) {
                        const [message, lvl, showMessageBox] = args;
                        if (lvl.intValue() >= ErrorLogger._level.intValue()) {
                            console.log(new Date().toLocaleString('en-US', this.dateFormatOptions) + ErrorLogger.LoggerName);
                            console.log("INFO: " + message);
                        }
                        /*_Logger.log(lvl, message);
                        if(showMessageBox==true &&
                                lvl.intValue() >= _Logger.getLevel().intValue() &&
                                lvl.intValue() < Integer.MAX_VALUE)
                        {
                        JOptionPane.showMessageDialog(null, message, "Message", JOptionPane.PLAIN_MESSAGE);
                        }//*/
                    }
                    else {
                        const [sourceClass, sourceMethod, message] = args;
                        ErrorLogger.LogMessage(sourceClass, sourceMethod, message, LogLevel_1.LogLevel.INFO, false);
                    }
                    break;
                }
                case 4: {
                    if (args[3] instanceof Boolean) {
                        const [sourceClass, sourceMethod, message, showMessageBox] = args;
                        ErrorLogger.LogMessage(sourceClass, sourceMethod, message, LogLevel_1.LogLevel.INFO, showMessageBox);
                    }
                    else {
                        const [sourceClass, sourceMethod, message, lvl] = args;
                        ErrorLogger.LogMessage(sourceClass, sourceMethod, message, lvl, false);
                    }
                    break;
                }
                case 5: {
                    const [sourceClass, sourceMethod, message, lvl, showMessageBox] = args;
                    if (lvl.intValue() >= ErrorLogger._level.intValue()) {
                        console.log(new Date().toLocaleString('en-US', this.dateFormatOptions) + sourceClass + "." + sourceMethod);
                        console.log(lvl.toString() + ": " + message);
                    }
                    /*
                    _Logger.logp(lvl, sourceClass, sourceMethod, message);
                    if(showMessageBox==true &&
                            lvl.intValue() >= _Logger.getLevel().intValue() &&
                            lvl.intValue() < Integer.MAX_VALUE)
                    {
                    //JOptionPane.showMessageDialog(null, message, "Message", JOptionPane.PLAIN_MESSAGE);
                    }//*/
                    break;
                }
                case 6: {
                    if (args[4] instanceof Array) {
                        const [sourceClass, sourceMethod, message, lvl, params, showMessageBox] = args;
                        if (lvl.intValue() >= ErrorLogger._level.intValue()) {
                            console.log(new Date().toLocaleString('en-US', this.dateFormatOptions) + sourceClass + "." + sourceMethod);
                            console.log(lvl.toString() + ": " + message);
                            for (let param of params) {
                                console.log(param.toString());
                            }
                        }
                        /*
                        _Logger.logp(lvl, sourceClass, sourceMethod, message, params);
                        if(showMessageBox==true &&
                                lvl.intValue() >= _Logger.getLevel().intValue() &&
                                lvl.intValue() < Integer.MAX_VALUE)
                        {
                        //JOptionPane.showMessageDialog(null, message, "Message", JOptionPane.PLAIN_MESSAGE);
                        }//*/
                    }
                    else {
                        const [sourceClass, sourceMethod, message, lvl, param1, showMessageBox] = args;
                        let params = new Array(1);
                        params[0] = param1;
                        ErrorLogger.LogMessage(sourceClass, sourceMethod, message, lvl, params, showMessageBox);
                    }
                    break;
                }
                default: {
                    throw Error(`Invalid number of arguments`);
                }
            }
        }
    }
    static LogException(...args) {
        switch (args.length) {
            case 3: {
                const [sourceClass, sourceMethod, exc] = args;
                ErrorLogger.LogException(sourceClass, sourceMethod, exc, LogLevel_1.LogLevel.INFO, false);
                break;
            }
            case 4: {
                if (args[3] instanceof Boolean) {
                    const [sourceClass, sourceMethod, exc, showMessageBox] = args;
                    ErrorLogger.LogException(sourceClass, sourceMethod, exc, LogLevel_1.LogLevel.INFO, showMessageBox);
                }
                else {
                    const [sourceClass, sourceMethod, exc, lvl] = args;
                    ErrorLogger.LogException(sourceClass, sourceMethod, exc, lvl, false);
                }
                break;
            }
            case 5: {
                const [sourceClass, sourceMethod, exc, lvl, showMessageBox] = args;
                if (lvl.intValue() >= ErrorLogger._level.intValue()) {
                    if (console) {
                        console.error(new Date().toLocaleString('en-US', this.dateFormatOptions) + sourceClass + "." + sourceMethod);
                        console.error(lvl.toString() + ": " + exc.message);
                        console.error(ErrorLogger.getStackTrace(exc));
                    }
                    else {
                        throw exc;
                    }
                }
                /*
                _Logger.logp(lvl, sourceClass, sourceMethod, exc.message,exc);
                //_Logger.logp(Level.INFO, sourceClass, sourceMethod, exc.message);
        
                if(exc != null && showMessageBox==true &&
                        lvl.intValue() >= _Logger.getLevel().intValue() &&
                        lvl.intValue() < Integer.MAX_VALUE)//shouldn't be showing if logging off
                {
                   //JOptionPane.showMessageDialog(null, exc.message, "Exception: " + sourceClass + "." + sourceMethod, JOptionPane.PLAIN_MESSAGE);
                }//*/
                break;
            }
            default: {
                throw Error(`Invalid number of arguments`);
            }
        }
    }
    static PrintList(list) {
        let message = "";
        for (let item of list) {
            message += item.toString() + "\n";
        }
        return message;
    }
    static PrintObjectMap(map) {
        let message = "";
        if (map != null) {
            for (let [key, val] of map) {
                message += key + " : " + val + "\n";
            }
        }
        //ErrorLogger.LogMessage(message);
        return message;
    }
    static PrintStringMap(map) {
        let message = "";
        if (map != null) {
            for (let [key, val] of map) {
                message += key + " : " + val + "\n";
            }
        }
        //ErrorLogger.LogMessage(message);
        return message;
    }
}
exports.ErrorLogger = ErrorLogger;
//# sourceMappingURL=ErrorLogger.js.map